<div id="manange-documents-container">
    <div class="row">

        <span class="float-right ml-auto" style="margin-right: 85px;">
            <button class="ml-2 btn btn-browse" type="button" (click)="openAddDocumentDialog()">{{ "Button.add_document" | translate}}</button>
        </span>

    </div>

    <div class="col-md-12 mt-3" *ngIf="documentsDataSource && documentsDataSource.data.length >0">
        <mat-form-field class="float-right">
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search">
        </mat-form-field>
        <!-- Material Table -->
        <table aria-describedby="document" aria-labelledby="document" mat-table [dataSource]="documentsDataSource" matSort class="col-md-12 mat-elevation-z8">
            <ng-container matColumnDef="fileDisplayName">
                <th id="doc-title" class="document-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Display Name </th>
                <td mat-cell *matCellDef="let element">
                    <a class="document-name-list-item" [href]='getDocURL(element)' rel="noopener" target="_blank">{{element.fileDisplayName}}
                            <span class="fa fa-external-link"></span>
                    </a>
                </td>
            </ng-container>

            <ng-container matColumnDef="uploadedTime">
                <th id="doc-upload-time" class="document-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.Uploaded_Date_Time" | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.uploadedTime| date:'MM/dd/yy, hh:mm a'}} </td>
            </ng-container>

            <ng-container matColumnDef="uploadedBy">
                <th id="doc-upload-by" class="document-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.Uploaded_by" | translate}} </th>
                <td mat-cell *matCellDef="let element"> {{element.uploadedBy}} </td>
            </ng-container>
            <ng-container matColumnDef="edit">
                <th id="doc-action" class="document-header-card" mat-header-cell *matHeaderCellDef>{{ "Label.Edit" | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <span class="action-control col-md-1">
                        <a matTooltip="Click to Edit" class="action-control-delete" (click)="editDocument(row);">
                            <img alt="Edit" [src]="commonService.commonFiles['edit']">
                        </a>
                    </span>
                </td>
            </ng-container>    
            <ng-container matColumnDef="delete">
                <th id="doc-action" class="document-header-card" mat-header-cell *matHeaderCellDef>{{ "Label.Delete" | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <span class="action-control col-md-1">
                        <a matTooltip="Click to Delete" class="action-control-delete" (click)="deleteDocument(row);">
                            <img alt="Delete" [src]="commonService.commonFiles['delete']">
                        </a>
                    </span>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
    </div>
</div>